// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

	});

	window.onload = function() {
		scrollW();
	};

	window.addEventListener('scroll', function(){
		scrollW();
	})

	//placehorder for input date mobile
	$("input[type=date]").on("input", function () {
		if ($(this).val().length > 0) {
			$(this).addClass("full");
		} else {
			$(this).removeClass("full");
		}
	});
	
}());

//Menu tablet
document.querySelector('.js-burger-menu').addEventListener('click', function(e){
	e.preventDefault();
	document.querySelector('.burger-menu').classList.add('open');
});
document.querySelector('.burger-cta').addEventListener('click', function(e){
	e.preventDefault();
	document.querySelector('.burger-menu').classList.add('open');
});
document.getElementById('burger-close').addEventListener('click', function(e){
	e.preventDefault();
	document.querySelector('.burger-menu').classList.remove('open');
});


// Menu Mobile
const cta_mobile = document.querySelector('.js-burger-menu');
const cta_mobile_text = document.querySelector('.js-burger-menu .text');
const header_open = document.querySelector('#header');
const menu = document.querySelector('.burger-menu');
const no_scroll = document.querySelector('body');
cta_mobile.addEventListener('click', function(){
	if (!this.classList.contains('open')) {
		this.classList.add('open');
		cta_mobile_text.innerHTML = "close"
		header_open.classList.add('open');
		menu.classList.add('open');
		no_scroll.classList.add('no-scroll');
	} else {
		this.classList.remove('open');
		cta_mobile_text.innerHTML = "menu";
		header_open.classList.remove('open');
		menu.classList.remove('open');
		no_scroll.classList.remove('no-scroll');
	}
});


function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;

	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');

			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if(document.querySelector(".sitemap , #gallery,.terms-and-conditions ") && !document.getElementById('header').classList.contains('up')){	
			document.getElementById('header').classList.add('up');
		}

	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//For Menu Tabs
document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
	btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu-restaurant__unitmenu').forEach(room => {
					room.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
							room.classList.add('active');
					}
			});
	});

	if (i === 0) btn.click();
});

 const select_menu = document.querySelector('#select-menu');
 if (select_menu != null) {
	
	 select_menu.addEventListener('change', _ => {
		document.querySelectorAll('.menu-restaurant__unitmenu').forEach(room => {
			room.classList.remove('active');
			if ( select_menu.value === 'all' || select_menu.value === room.dataset.tag ) {
					room.classList.add('active');
			}
		});
	 });
 }

 //Home Menu
 if (document.querySelector('.menu-home__img') != null) {
 document.querySelector('.menu-home__img').classList.add('active');
 document.querySelectorAll('.menu-home__tab').forEach((btn, i) => {
	btn.addEventListener('mouseover', _ => {
			document.querySelectorAll('.menu-home__tab').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu-home__img').forEach(img => {
					img.classList.remove('active');
					if ( btn.dataset.tag === img.dataset.tag ) {
							img.classList.add('active');
					}
			});
	});
});  
}

//OPEN TABLE WIDGET ON DESKTOP
function displayOpenTableWidgetDesktop(){
	let trigger = document.querySelector(`[data-open_table_bw="trigger"]`),
		widget = document.querySelector(`[data-open_table_bw="container"]`);

	trigger.addEventListener( 'click', () => {
		let heightInnerTheWidget = widget.querySelector(`[id^="ot-widget-container"]`);
		if( widget.getAttribute(`style`) )
			widget.removeAttribute(`style`)
		else
			widget.setAttribute(`style`, `max-height:${heightInnerTheWidget.clientHeight}px`)
	} );
}

document.addEventListener('DOMContentLoaded', () => {
	if( document.querySelector(`[data-open_table_bw="trigger"]`) ){
		displayOpenTableWidgetDesktop();
	} 
});